/**
 * CardBack — the generated ornamental card back.
 *
 * The back art is real depictive illustration (a damask interlace), so it comes
 * from the asset pipeline (public/generated/cards/card-back.*), NOT hand-drawn
 * SVG. We render a <picture> with avif/webp/png so the browser picks the
 * smallest format. It fills its container edge-to-edge; the parent owns the
 * rounded-corner clip and shadow.
 */
import { memo } from 'react';

import { CARD_ART } from './art';

export const CardBack = memo(function CardBack(): React.JSX.Element {
  const art = CARD_ART.back;
  return (
    <picture className="card-art card-art--back">
      <source type="image/avif" srcSet={art.avif} />
      <source type="image/webp" srcSet={art.webp} />
      <img src={art.png} alt="" aria-hidden="true" decoding="async" draggable={false} />
    </picture>
  );
});
